import { render, staticRenderFns } from "./GeneralCargoPerformance.vue?vue&type=template&id=58d914d3&scoped=true"
import script from "./GeneralCargoPerformance.vue?vue&type=script&lang=js"
export * from "./GeneralCargoPerformance.vue?vue&type=script&lang=js"
import style0 from "./GeneralCargoPerformance.vue?vue&type=style&index=0&id=58d914d3&prod&lang=scss&scoped=true"
import style1 from "./GeneralCargoPerformance.vue?vue&type=style&index=1&id=58d914d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d914d3",
  null
  
)

export default component.exports